<div v-if="inline">
  <div class="card-body">

    <div class="d-flex flex-row align-items-center mb-3">
      <div class="form-check me-3">
        <input
          type="radio"
          class="form-check-input"
          id="event_agenda_description_inline"
          value="agenda_description"
          v-model="agenda_mode"
        />
        <label for="event_agenda_description_inline" class="form-check-label">Create Agenda</label>
      </div>
      <div class="form-check me-3">
        <input
          type="radio"
          class="form-check-input"
          id="event_agenda_upload_inline"
          value="upload_agenda"
          v-model="agenda_mode"
        />
        <label for="event_agenda_upload_inline" class="form-check-label">Upload Agenda</label>
      </div>
    </div>

    <div v-if="agenda_mode === 'upload_agenda'">
      <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
        <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
          <label for="event_agenda_file_input_inline" class="btn btn-primary text-xxs rounded text-white">
            <i class="bx bx-image-add file-upload-icon"></i> Add event content/agenda
          </label>
          <input
            type="file"
            id="event_agenda_file_input_inline"
            class="file-input d-none"
            :accept="accepted_file_types"
            @change="handle_agenda_file_upload"
          />
          <div v-if="file_name" class="text-xxs text-secondary fst-italic mt-1">
            <span class="fw-500">File name:</span> {{ file_name }}
          </div>
          <div v-if="file_error" class="text-xxs text-danger fst-italic mt-1">{{ file_error }}</div>
          <div v-if="upload_preview_url" class="mt-3 w-100">
            <div v-if="upload_preview_type === 'pdf'">
              <iframe :src="upload_preview_url" width="100%" height="400px"></iframe>
            </div>
            <div v-else-if="upload_preview_type === 'word'">
              <iframe :src="upload_preview_url" width="100%" height="400px"></iframe>
            </div>
            <div v-else-if="upload_preview_type === 'excel'">
              <iframe :src="upload_preview_url" width="100%" height="400px"></iframe>
            </div>
            <div v-else-if="upload_preview_type === 'powerpoint'">
              <iframe :src="upload_preview_url" width="100%" height="400px"></iframe>
            </div>
            <div v-else-if="upload_preview_type === 'image'">
              <img :src="upload_preview_url" class="img-fluid" alt="Agenda Preview" />
            </div>
          </div>
          <div v-else-if="upload_preview_type && upload_preview_type !== 'pdf' && upload_preview_type !== 'image'" class="text-muted text-xxs mt-2">
            Preview will be available after saving this file.
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="agenda_mode === 'agenda_description'" class="mt-2 border rounded p-2">
      <div v-for="(item, index) in agenda" :key="index" class="mb-2 p-2 border rounded bg-light">
        <div class="row g-1">
          <div class="col-md-5">
            <label class="form-label text-xxs fw-500">Topic Description</label><span class="text-danger">*</span>
            <input
              type="text"
              v-model="item.description"
              class="form-control rounded text-xxs"
              placeholder="e.g. Welcome & Intro"
            />
            <p v-if="agenda_errors['agenda_description' + index]" class="text-danger text-xxs">
              {{ agenda_errors['agenda_description' + index] }}
            </p>
          </div>
          <div class="col-md-2">
            <label class="form-label text-xxs fw-500">Start Time</label><span class="text-danger">*</span>
            <input type="time" v-model="item.start_time" class="form-control rounded text-xxs" />
            <p v-if="agenda_errors['agenda_start_time' + index]" class="text-danger text-xxs">
              {{ agenda_errors['agenda_start_time' + index] }}
            </p>
          </div>
          <div class="col-md-2">
            <label class="form-label text-xxs fw-500">End Time</label><span class="text-danger">*</span>
            <input type="time" v-model="item.end_time" class="form-control rounded text-xxs" />
            <p v-if="agenda_errors['agenda_end_time' + index]" class="text-danger text-xxs">
              {{ agenda_errors['agenda_end_time' + index] }}
            </p>
          </div>
          <div class="col-md-3">
            <label class="form-label text-xxs fw-500">Speaker</label>
            <input
              type="text"
              v-model="item.speaker"
              class="form-control rounded text-xxs"
              placeholder="e.g. John Doe"
            />
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-link text-danger text-xxs" @click="remove_agenda_item(index)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>

      <button class="btn btn-primary btn-sm rounded text-xxs" type="button" @click="add_agenda_item">
        <i class="bi bi-plus"></i> Add Agenda Item
      </button>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <button
        class="btn btn-sm btn-primary rounded text-xxs cursor-pointer nav-item.position-relative"
        type="button"
        :disabled="agenda_mode === 'upload_agenda' ? !upload_file || is_uploading : is_uploading"
        @click="create_agenda"
      >
        Save
      </button>
    </div>
  </div>
</div>

<teleport v-else to="body">
  <div class="modal fade" id="create_event_agenda_modal" tabindex="-1" aria-labelledby="createEventAgendaLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white text-xxs" id="createEventAgendaLabel">
            {{ has_existing_agenda ? 'Edit Event Agenda' : 'Create Event Agenda' }}
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="reset_create_form"
          ></button>
        </div>
        <div class="modal-body">
          <div class="d-flex flex-row align-items-center mb-3">
            <div class="form-check me-3">
              <input
                type="radio"
                class="form-check-input"
                id="event_agenda_description"
                value="agenda_description"
                v-model="agenda_mode"
              />
              <label for="event_agenda_description" class="form-check-label">Create Agenda</label>
            </div>
            <div class="form-check me-3">
              <input
                type="radio"
                class="form-check-input"
                id="event_agenda_upload"
                value="upload_agenda"
                v-model="agenda_mode"
              />
              <label for="event_agenda_upload" class="form-check-label">Upload Agenda</label>
            </div>
          </div>

          <div v-if="agenda_mode === 'upload_agenda'">
            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
              <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
                <label for="event_agenda_file_input" class="btn btn-primary text-xxs rounded text-white">
                  <i class="bx bx-image-add file-upload-icon"></i> Add event content/agenda
                </label>
                <input
                  type="file"
                  id="event_agenda_file_input"
                  class="file-input d-none"
                  :accept="accepted_file_types"
                  @change="handle_agenda_file_upload"
                />
                <div v-if="file_name" class="text-xxs text-secondary fst-italic mt-1">
                  <span class="fw-500">File name:</span> {{ file_name }}
                </div>
                <div v-if="file_error" class="text-xxs text-danger fst-italic mt-1">{{ file_error }}</div>
                <div v-if="upload_preview_url" class="mt-3 w-100">
                  <div v-if="upload_preview_type === 'pdf'">
                    <iframe :src="upload_preview_url" width="100%" height="400px"></iframe>
                  </div>
                  <div v-else-if="upload_preview_type === 'word'">
                    <iframe :src="upload_preview_url" width="100%" height="400px"></iframe>
                  </div>
                  <div v-else-if="upload_preview_type === 'excel'">
                    <iframe :src="upload_preview_url" width="100%" height="400px"></iframe>
                  </div>
                  <div v-else-if="upload_preview_type === 'powerpoint'">
                    <iframe :src="upload_preview_url" width="100%" height="400px"></iframe>
                  </div>
                  <div v-else-if="upload_preview_type === 'image'">
                    <img :src="upload_preview_url" class="img-fluid" alt="Agenda Preview" />
                  </div>
                </div>
                <div v-else-if="upload_preview_type && upload_preview_type !== 'pdf' && upload_preview_type !== 'image'" class="text-muted text-xxs mt-2">
                  Preview will be available after saving this file.
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="agenda_mode === 'agenda_description'" class="mt-2 border rounded p-2">
            <div v-for="(item, index) in agenda" :key="index" class="mb-2 p-2 border rounded bg-light">
              <div class="row g-1">
                <div class="col-md-5">
                  <label class="form-label text-xxs fw-500">Topic Description</label><span class="text-danger">*</span>
                  <input
                    type="text"
                    v-model="item.description"
                    class="form-control rounded text-xxs"
                    placeholder="e.g. Welcome & Intro"
                  />
                  <p v-if="agenda_errors['agenda_description' + index]" class="text-danger text-xxs">
                    {{ agenda_errors['agenda_description' + index] }}
                  </p>
                </div>
                <div class="col-md-2">
                  <label class="form-label text-xxs fw-500">Start Time</label><span class="text-danger">*</span>
                  <input type="time" v-model="item.start_time" class="form-control rounded text-xxs" />
                  <p v-if="agenda_errors['agenda_start_time' + index]" class="text-danger text-xxs">
                    {{ agenda_errors['agenda_start_time' + index] }}
                  </p>
                </div>
                <div class="col-md-2">
                  <label class="form-label text-xxs fw-500">End Time</label><span class="text-danger">*</span>
                  <input type="time" v-model="item.end_time" class="form-control rounded text-xxs" />
                  <p v-if="agenda_errors['agenda_end_time' + index]" class="text-danger text-xxs">
                    {{ agenda_errors['agenda_end_time' + index] }}
                  </p>
                </div>
                <div class="col-md-3">
                  <label class="form-label text-xxs fw-500">Speaker</label>
                  <input
                    type="text"
                    v-model="item.speaker"
                    class="form-control rounded text-xxs"
                    placeholder="e.g. John Doe"
                  />
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-link text-danger text-xxs" @click="remove_agenda_item(index)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>

            <button class="btn btn-primary btn-sm rounded text-xxs" type="button" @click="add_agenda_item">
              <i class="bi bi-plus"></i> Add Agenda Item
            </button>
          </div>
        </div>
        <div class="modal-footer border-0">
          <button
            class="btn btn-primary btn-sm text-xxs"
            type="button"
            :disabled="agenda_mode === 'upload_agenda' ? !upload_file || is_uploading : is_uploading"
            @click="create_agenda"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- modal to view Agenda -->
<teleport to="body">
  <div class="modal fade" id="event_agenda_modal" tabindex="-1" aria-labelledby="eventAgendaModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white text-xxs" id="eventAgendaModalLabel">View Event Agenda</h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="reset_preview"
          ></button>
        </div>
        <div class="modal-body table-responsive">
          <div v-if="selected_event_agenda?.agenda?.length > 0" class="d-flex">
            <h6 class="me-auto">Manual Agenda</h6>
            <button
              @click="exportPDF"
              class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 ms-2 mb-2 justify-content-start"
            >
              Export to PDF
            </button>
          </div>
          <table v-if="selected_event_agenda?.agenda?.length > 0" class="table table-striped text-xxs">
            <thead class="text-uppercase btn-primary text-white sticky-top">
              <tr>
                <th class="fw-light">Topic</th>
                <th class="fw-light">Start time</th>
                <th class="fw-light">End Time</th>
                <th class="fw-light">Speaker</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="agenda in selected_event_agenda.agenda" :key="agenda.id">
                <td>{{ agenda?.description }}</td>
                <td>{{ agenda?.start_time }}</td>
                <td>{{ agenda?.end_time }}</td>
                <td>{{ agenda.speaker }}</td>
              </tr>
            </tbody>
          </table>
          <h6 v-if="preview_document_url">Uploaded agenda</h6>
          <div v-if="preview_document_type === 'pdf'">
            <iframe
              :src="preview_document_url"
              width="100%"
              height="600px"
              @load="loading_preview = false"
            ></iframe>
          </div>
          <div v-else-if="preview_document_type === 'word'">
            <iframe
              :src="preview_document_url"
              width="100%"
              height="600px"
              @load="loading_preview = false"
            ></iframe>
          </div>
          <div v-else-if="preview_document_type === 'excel'">
            <iframe
              :src="preview_document_url"
              width="100%"
              height="600px"
              @load="loading_preview = false"
            ></iframe>
          </div>
          <div v-else-if="preview_document_type === 'powerpoint'">
            <iframe
              :src="preview_document_url"
              width="100%"
              height="600px"
              @load="loading_preview = false"
            ></iframe>
          </div>
          <div v-else-if="preview_document_type === 'image'">
            <img
              :src="preview_document_url"
              class="img-fluid"
              alt="Document Image"
              @load="loading_preview = false"
            >
          </div>
          <div v-else-if="!selected_event_agenda?.agenda?.length && !preview_document_url" class="text-muted text-xxs">
            No agenda available for this event.
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
